import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from '@tanstack/react-router';
import { LoginPage } from './LoginPage';

export const AuthGuard: React.FC = () => {
    const oktaAuthContext = useOktaAuth();
    const oktaAuth = oktaAuthContext?.oktaAuth;
    const authState = oktaAuthContext?.authState;

    // If oktaAuth is undefined, it means auth is disabled (OktaProvider returned children directly)
    if (!oktaAuth) {
        return <Outlet />;
    }

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
        }
    }, [oktaAuth, authState]);

    if (!authState) {
        return <div>Loading authentication...</div>;
    }

    if (!authState.isAuthenticated) {
        return <LoginPage />;
    }

    return <Outlet />;
};
